import { FetchStatus } from '../tachograph/diagram/TachographComponents';

export function provideTargetIcon(vehicleCategory: string): string {
  switch (vehicleCategory) {
    case 'adapterFront':
      return 'svg/adapter-front.svg';
    case 'adapterSide':
      return 'svg/adapter-side.svg';
    case 'airplane':
      return 'svg/airplane.svg';
    case 'beehive':
      return 'svg/beehive.svg';
    case 'bicycle':
      return 'svg/bicycle.svg';
    case 'boomLift':
      return 'svg/boom-lift.svg';
    case 'bus':
      return 'svg/bus.svg';
    case 'concreteMixer':
      return 'svg/concrete-mixer.svg';
    case 'container':
      return 'svg/container.svg';
    case 'dropDeckTrailer':
      return 'svg/drop-deck-trailer.svg';
    case 'dumper':
      return 'svg/dumper.svg';
    case 'excavatorTracks':
      return 'svg/excavator-tracks.svg';
    case 'excavatorWheels':
      return 'svg/excavator-wheels.svg';
    case 'forklift':
      return 'svg/forklift.svg';
    case 'garbageTruck':
      return 'svg/garbage-truck.svg';
    case 'generator':
      return 'svg/generator.svg';
    case 'train':
      return 'svg/train.svg';
    case 'machinery':
      return 'svg/machinery.svg';
    case 'microbus':
      return 'svg/microbus.svg';
    case 'motorbike':
      return 'svg/motorbike.svg';
    case 'offroad':
      return 'svg/offroad.svg';
    case 'person':
      return 'svg/person.svg';
    case 'roller':
      return 'svg/roller.svg';
    case 'sailboat':
      return 'svg/sailboat.svg';
    case 'ship':
      return 'svg/ship.svg';
    case 'storehouse':
      return 'svg/storehouse.svg';
    case 'tanker':
      return 'svg/tanker.svg';
    case 'tractor':
      return 'svg/tractor.svg';
    case 'trailer':
      return 'svg/trailer.svg';
    case 'trafficLight':
      return 'svg/traffic-light.svg';
    case 'truckLong':
      return 'svg/truck-long.svg';
    case 'truck':
      return 'svg/truck.svg';
    case 'car':
      return 'svg/car.svg';
    case 'dog':
      return 'svg/dog.svg';
    case 'quad':
      return 'svg/quad.svg';
    default:
      return 'svg/car.svg';
  }
}

export function provideFlagIcon(nation: string): string {
  switch (nation) {
    case 'en':
      return 'svg/flag-uk.svg';
    case 'hu':
      return 'svg/flag-hu.svg';
    case 'sk':
      return 'svg/flag-sk.svg';
    case 'ro':
      return 'svg/flag-ro.svg';
    case 'sr':
      return 'svg/flag-sr.svg';
    case 'hr':
      return 'svg/flag-hr.svg';
    case 'cz':
      return 'svg/flag-cz.svg';
    case 'sl':
      return 'svg/flag-sl.svg';
    case 'it':
      return 'svg/flag-it.svg';
    default:
      return '';
  }
}

export function provideTachographIcon(status: FetchStatus) {
  switch (status) {
    case 'idle':
      return 'svg/tachograph-card-idle.svg';
    case 'empty':
      return 'svg/tachograph-card-empty.svg';
    case 'data':
      return 'svg/tachograph-card-noData.svg';
    default:
      return '';
  }
}
